import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b33d18e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-progressbar" }
const _hoisted_2 = { class: "oxd-progressbar-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_text = _resolveComponent("oxd-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.styles),
        class: _normalizeClass(_ctx.classes)
      }, null, 6)
    ]),
    (_ctx.showLabel)
      ? (_openBlock(), _createBlock(_component_oxd_text, {
          key: 0,
          class: "oxd-progressbar-text",
          tag: "p"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.progressText), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}